import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import {
  Box, Button,
  Dialog, DialogActions,
  DialogContent,
  DialogTitle, FormControl, FormHelperText,
  IconButton,
  InputLabel,
  MenuItem, Select, TextField,
  Typography
} from '@material-ui/core'
import { AuthenticatedUserContext } from '../../../../AuthenticatedUserContext'
import { FormattedMessage, useIntl } from 'react-intl'
import CloseIcon from '@material-ui/icons/Close'
import Alert from '@material-ui/lab/Alert'
import { NamedRoutes } from '../../../../routes'
import { FormLoader } from '../../../Loader/FormLoader'
import { useStyles } from '../../../Workspace/DashboardActionLinks/Styles'
import { useFormik } from 'formik'
import { nonCoreLinkFormValidation } from '../../../../utils/validationSchema'
import { LanguageConsumer, LanguageContext } from '../../../../LanguageContext'
import PhoneInput from 'react-phone-input-2'
import ar from 'react-phone-input-2/lang/ar.json'
import Item from '../../CompanyPage/CompaniesInfo/Item'
import { formatPhoneNumber } from '../../../../utils/helpers'
import Moment from 'react-moment'
import NonCoreRequestPDFContent from './PDFContent'
import html2canvas from 'html2canvas'
import jsPDF from "jspdf"

const NonCoreLinkForm = ({ Transition }) => {
  const classes = useStyles()
  const intl = useIntl()
  const {
    verifiedCompaniesContacts,
    companiesContactsLoading,
    getAllCompaniesContacts,
    userCompaniesLoading,

    handleNonCoreLinkFormSubmit,
    resetNonCoreLinkStatus,
    nonCoreLinkFailure,
    nonCoreLinkFailureMessage,
    nonCoreLinkSuccessData,

    nonCoreLinkGuidesContent,
    nonCoreLinkGuidesContentLoading,
    nonCoreLinkGuidesContentFailure,
    nonCoreLinkGuidesContentFailureMessage
  } = useContext(AuthenticatedUserContext)

  const { locale } = useContext(LanguageContext)


  const [viewNonCoreLinkFormDialog, setViewNonCoreLinkFormDialog] = React.useState(false)
  const [openNonCoreLinkFormDialog, setOpenNonCoreLinkFormDialog] = React.useState(false)

  const handleNonCoreLinkFormDialog = () => {
    if (!openNonCoreLinkFormDialog) {
      if (!!getAllCompaniesContacts) {
        getAllCompaniesContacts()
      }
      setViewNonCoreLinkFormDialog(true)
    } else {
      setTimeout(() => {
        setViewNonCoreLinkFormDialog(false)
        resetNonCoreLinkForm()
      }, 500)
    }
    setOpenNonCoreLinkFormDialog(!openNonCoreLinkFormDialog)
  }

  const nonCoreLinkForm = useFormik({
    initialValues: {
      tax_id: '',
      email: '',
      mobile: '',
      contact_info_id: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: nonCoreLinkFormValidation,
    onSubmit: ((values, actions) => {
      handleNonCoreLinkFormSubmit(values, actions)
    })
  })

  const resetNonCoreLinkForm = () => {
    nonCoreLinkForm.resetForm()
    resetNonCoreLinkStatus()
  }


  const handleCompanyContactChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    nonCoreLinkForm.setFieldValue('contact_info_id', event.target.value.toString())
    if (!!event.target.value.toString()) {
      let companyContact = verifiedCompaniesContacts.filter((contact) => contact.id.toString() === event.target.value.toString())[0]
      nonCoreLinkForm.setFieldValue('tax_id', companyContact.tax_id)
      nonCoreLinkForm.setFieldValue('email', companyContact.email)
      nonCoreLinkForm.setFieldValue('mobile', companyContact.phone)
    } else {
      nonCoreLinkForm.setFieldValue('tax_id', '')
      nonCoreLinkForm.setFieldValue('email', '')
      nonCoreLinkForm.setFieldValue('mobile', '20')
    }
    setTimeout(() => nonCoreLinkForm.setFieldTouched('tax_id', true, true), 50)
  }

  const generatePDF = () => {
    html2canvas(document.getElementById('pdfContent'), {
      onclone: function(clonedDoc) {
        clonedDoc.getElementById('pdfContent').style.visibility = 'visible'
      },
      x: 0,
      y: 0,
      scrollX: 0,
      scrollY: 0
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const pdf = new jsPDF('p', 'px', 'a4')
        pdf.setProperties({
          title: intl.formatMessage({ id: 'nonCoreLink.print.Title' }, { req_num: nonCoreLinkSuccessData?.request_number || 'N/A' }),
          subject: 'Info about PDF',
          author: 'PDFAuthor',
          creator: 'E-Finance'
        })
        const imgProps = pdf.getImageProperties(imgData)
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
        pdf.autoPrint({ variant: 'non-conform' })
        window.open(URL.createObjectURL(pdf.output('blob')), 'test')
      })
  }
  return (
    <div className={classes.DashboardActionLinksItem}>
      <h4><FormattedMessage id={'DashboardContent.ActionLinks.NonCoreLink.title'}/></h4>
      <Button size="large" disabled={!!userCompaniesLoading} onClick={handleNonCoreLinkFormDialog} variant="contained"
              color="primary">
        <FormattedMessage id={'DashboardContent.ActionLinks.NonCoreLink'}/>
      </Button>
      {!!viewNonCoreLinkFormDialog &&
      <Dialog
        keepMounted
        fullWidth
        maxWidth={'sm'}
        open={openNonCoreLinkFormDialog}
        classes={{ paper: classes.LinkCompanyDialogPaper }}
        TransitionComponent={Transition}
        onClose={handleNonCoreLinkFormDialog}
        aria-labelledby="BasicInfoDialog"
        aria-describedby="BasicInfoDialog"
      >
        <DialogTitle disableTypography className={classes.LinkCompanyDialogHeader}>
          <Typography variant="h5"><FormattedMessage id='NonCoreLink.Dialog.Title'/></Typography>
          <IconButton
            edge={false}
            className={classes.LinkCompanyDialogClose}
            color="inherit"
            aria-label="close dialog"
            onClick={handleNonCoreLinkFormDialog}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.LinkCompanyDialogContent}>
          <Box px={4} pt={4} pb={0.5} className={classes.EcommerceUINWrapper}>

            {!companiesContactsLoading && !verifiedCompaniesContacts?.length &&
            <Alert severity="error">
              <FormattedMessage id='NonCoreLink.Contacts.NotExistError'
                                values={{
                                  a: chunks => <NavLink
                                    to={NamedRoutes.workspace.editCompanyContact}>{chunks}</NavLink>
                                }}/>
            </Alert>
            }

            {!!nonCoreLinkFailure && !!nonCoreLinkFailureMessage &&
            <Alert severity="error">{nonCoreLinkFailureMessage}</Alert>
            }

            {!!Object.keys(nonCoreLinkSuccessData || {})?.length
              ? <>
                <Box my={2} className={classes.EcommerceUINContent}>

                  <Item asTable label={<FormattedMessage id='nonCoreLink.requestNumber'/>}
                        value={nonCoreLinkSuccessData?.request_number || 'N/A'}/>

                  <Item asTable label={<FormattedMessage id='incentivesForm.placeholder.companyTaxId'/>}
                        value={nonCoreLinkSuccessData?.tax_id || 'N/A'}/>

                  <Item asTable label={<FormattedMessage id='linkCompanyForm.placeholder.email'/>}
                        value={<a
                          href={`mailto:${nonCoreLinkSuccessData?.email}`}>{nonCoreLinkSuccessData?.email}</a>}/>

                  <Item asTable label={<FormattedMessage id='linkCompanyForm.placeholder.mobile'/>}
                        value={<a className={classes.phoneNumFormat}
                                  href={`tel:${nonCoreLinkSuccessData?.phone}`}>{formatPhoneNumber(nonCoreLinkSuccessData?.phone)}</a>}/>

                  <Item asTable label={<FormattedMessage id='nonCoreLink.expiry_date'/>}
                        value={<Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                       format="Do MMMM YYYY h:mm a">{nonCoreLinkSuccessData?.expiration_date}</Moment>}/>

                  <Item asTable label={<FormattedMessage id='nonCoreLink.tax_office_number'/>}
                        value={nonCoreLinkSuccessData?.tax_office_number || 'N/A'}/>

                  <Item asTable label={<FormattedMessage id='PaymentHeader.userName'/>}
                        value={nonCoreLinkSuccessData?.username || 'N/A'}/>

                </Box>
                <div className={classes.guidesContentWrapper}>
                  {!!nonCoreLinkGuidesContentLoading &&
                  <Box p={5}><FormLoader loading={true}/></Box>}

                  {!!nonCoreLinkGuidesContentFailure && !!nonCoreLinkGuidesContentFailureMessage &&
                  <Alert severity="error">{nonCoreLinkGuidesContentFailureMessage}</Alert>
                  }

                  {!!Object.keys(nonCoreLinkGuidesContent || {}).length && !!nonCoreLinkGuidesContent.content &&
                  <div dangerouslySetInnerHTML={{
                    __html: nonCoreLinkGuidesContent.content
                  }}></div>
                  }
                </div>
                <NonCoreRequestPDFContent
                  locale={locale}
                  requestDetails={nonCoreLinkSuccessData}
                />
              </>

              : <form onSubmit={nonCoreLinkForm.handleSubmit} noValidate autoComplete="off"
                      className={classes.formWrapper}>

                <div className={classes.LinkCompanyFormRow + ' ' + classes.LinkCompanyFormRowSelect}>
                  <InputLabel id="nonCoreLinkForm.tax_id"><FormattedMessage
                    id='Fields.label.companyTaxId'/></InputLabel>
                  <FormControl variant='outlined'>
                    <Select
                      fullWidth
                      id="linkCompanyForm.tax_id"
                      margin="dense"
                      displayEmpty
                      MenuProps={{ disableScrollLock: true }}
                      name="contact_info_id"
                      value={nonCoreLinkForm.values.contact_info_id}
                      onChange={handleCompanyContactChange}
                      onBlur={nonCoreLinkForm.handleBlur}
                      error={nonCoreLinkForm.errors.tax_id && nonCoreLinkForm.touched.tax_id !== undefined}
                    >
                      <MenuItem value=''><FormattedMessage
                        id='incentivesForm.placeholder.companyTaxId'/></MenuItem>
                      {!!verifiedCompaniesContacts.length && verifiedCompaniesContacts.map((companyContact) => (
                        <MenuItem key={companyContact.id}
                                  value={companyContact.id}>{companyContact.tax_id}</MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      <FormattedMessage id='linkCompanyForm.addCompanyContact'
                                        values={{
                                          a: chunks => <NavLink
                                            to={NamedRoutes.workspace.editCompanyContact}
                                            onClick={handleNonCoreLinkFormDialog}>{chunks}</NavLink>
                                        }}/>
                    </FormHelperText>
                    {nonCoreLinkForm.errors.tax_id && nonCoreLinkForm.touched.tax_id && (
                      <FormHelperText error={true}>{nonCoreLinkForm.errors.tax_id}</FormHelperText>
                    )}
                  </FormControl>
                </div>

                <div className={classes.LinkCompanyFormRow}>
                  <InputLabel id="nonCoreLinkForm.email"> {<FormattedMessage
                    id='Fields.label.taxEmail'/>} </InputLabel>
                  <FormControl variant="outlined">
                    <TextField
                      placeholder={intl.formatMessage({ id: 'linkCompanyForm.placeholder.email' })}
                      id="nonCoreLinkForm.email"
                      type={'email'}
                      disabled={true}
                      margin="dense"
                      variant="outlined"
                      name='email'
                      value={nonCoreLinkForm.values.email}
                    />
                  </FormControl>
                </div>

                <div className={classes.LinkCompanyFormRow}>
                  <InputLabel id="nonCoreLinkForm.mobile"><FormattedMessage
                    id='Fields.label.mobile'/></InputLabel>
                  <LanguageConsumer>
                    {({ locale }) => (
                      <div className={classes.PhoneInputWrapper}>
                        <PhoneInput
                          disabled={true}
                          enableSearch={false}
                          jumpCursorToEnd={true}
                          country={'eg'}
                          localization={locale === 'ar' ? ar : ''}
                          specialLabel={''}
                          excludeCountries={['il']}
                          value={nonCoreLinkForm.values.mobile}
                        />
                      </div>
                    )}
                  </LanguageConsumer>
                </div>

                {nonCoreLinkForm.isSubmitting && <FormLoader loading={true}/>}
              </form>
            }
          </Box>
        </DialogContent>
        <DialogActions className={classes.LinkCompanyDialogFooter}>

          {!!Object.keys(nonCoreLinkSuccessData || {})?.length
            ? <Button size="large" variant="contained" color="primary"
              onClick={generatePDF} >
              <FormattedMessage id='PaymentOrder.ActionLinks.print'/>
            </Button>
            : <Button type="submit" color={'primary'} size={'large'} variant={'contained'}
                      onClick={nonCoreLinkForm.handleSubmit}
                      disabled={nonCoreLinkForm.isSubmitting || !nonCoreLinkForm.isValid}
                      className={classes.LinkCompanyFormSubmit}>
              <FormattedMessage id={`NonCoreLink.button.submit`}/>
            </Button>
          }

          <Button onClick={handleNonCoreLinkFormDialog} color="primary">
            <FormattedMessage
              id={!!Object.keys(nonCoreLinkSuccessData || {})?.length ? 'PaymentOrder.ActionLinks.close' : 'ChangePhone.DialogActions.cancel'}/>
          </Button>
        </DialogActions>
      </Dialog>
      }
    </div>
  )
}

export default NonCoreLinkForm
